import React from 'react';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  id?: string;
}

/**
 * Reusable DetailRow component for consistent field display
 * Provides semantic HTML (dt/dd) with accessibility features
 */
export const DetailRow: React.FC<DetailRowProps> = ({ label, value, id }) => {
  const labelId = id ? `${id}-label` : undefined;
  const valueId = id ? `${id}-value` : undefined;

  return (
    <div className="flex gap-4 text-sm leading-relaxed mb-2">
      <dt id={labelId} className="font-semibold min-w-[180px] max-w-[180px] text-right text-gray-800 m-0 pr-2">
        {label}
      </dt>
      <dd id={valueId} className="text-gray-600 m-0 flex-1">
        {value}
      </dd>
    </div>
  );
};
